import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField, Button, } from '@material-ui/core';
import { basicDetailsImageUploadAvatarStyle } from './style/basicDetailsImageUploadAvatarStyle';

/**
 * region for hepers*/
import typing from '../../../helpers/typing';

class BasicDetailsImageAvatarUpload extends Component {

    state = {
        minisiteLogoUrl: '',
        minisiteLogoFile: null,
        minisiteLogoName: ''
    };

    componentWillReceiveProps(nextProps) {
        const self = this;
        if (typing.isDefined(nextProps.minisiteLogoUrl)&& !typing.isEmpty(nextProps.minisiteLogoUrl) &&  !typing.isDefined(nextProps.minisiteLogoFile)) {
            let minisiteLogoUrl = "https://d1udni7k17y86t.cloudfront.net" + nextProps.minisiteLogoUrl;
            var minisiteLogoName = minisiteLogoUrl.substring(minisiteLogoUrl.lastIndexOf('/') + 1);
            this.setState({ minisiteLogoName: minisiteLogoName, minisiteLogoUrl: minisiteLogoUrl });
        } else {
            if (typing.isDefined(nextProps.minisiteLogoFile)) {
                let reader = new FileReader();
                let minisiteLogoFile = nextProps.minisiteLogoFile;
                reader.onloadend = () => {
                    self.setState({
                        minisiteLogoFile: minisiteLogoFile,
                        minisiteLogoUrl: reader.result,
                        minisiteLogoName: minisiteLogoFile.name
                    });
                }
                reader.readAsDataURL(minisiteLogoFile);
            } else {
                self.setState({
                    minisiteLogoFile: "",
                    minisiteLogoUrl: "",
                    minisiteLogoName: ""
                });
            }
        }
    }

    onChange = (e) => {
        e.preventDefault();
        const self = this;
        let reader = new FileReader();
        let minisiteLogoFile = e.target.files[0];

        reader.onloadend = () => {
            self.setState({
                minisiteLogoFile: minisiteLogoFile,
                minisiteLogoUrl: reader.result,
                minisiteLogoName: minisiteLogoFile.name
            }, function () {
                self.props.onAttributeUpdateImage({ minisiteLogo: self.state.minisiteLogoFile,minisiteLogoUrl:"" });
            }
            );
        }
        reader.readAsDataURL(minisiteLogoFile);
    };
    onClick = (e) => {
        e.preventDefault();
        const self = this;
        self.setState({
            minisiteLogoNameBinary: null,
            minisiteLogo: '',
            minisiteLogoUrl: ''
        }, function () {
            self.props.onAttributeUpdateImage({ minisiteLogo: null, minisiteLogoUrl:"" });
        })
    };

    render() {
        const { classes } = this.props;
        return (
            <Grid container spacing={4} direction="row" justify="flex-end" alignItems="flex-start">
                <Grid item sm={4}>
                    <div className={classes.avatar}>
                        {
                            this.state.minisiteLogoUrl && <img src={this.state.minisiteLogoUrl} alt={this.state.minisiteLogoName ? this.state.minisiteLogoName : ""} className={classes.img} />
                        }
                        {
                            !this.state.minisiteLogoUrl && <div className={classes.noImage}></div>
                        }
                    </div>
                </Grid>
                <Grid item sm={8}>
                    <Grid container item xs={12}>
                        <Grid container>
                            <Grid item sm={12}>
                                <TextField
                                    label="LOGO"
                                    id="logo"
                                    className={classes.textFieldUpload}
                                    placeholder="Choose an image for site"
                                    fullWidth
                                    margin="normal"
                                    value={this.state.minisiteLogoName ? this.state.minisiteLogoName : ""}
                                    InputLabelProps={{
                                        shrink: true,
                                        readOnly: true
                                    }}
                                />
                                <input
                                    type="file"
                                    label="Choose your logo"
                                    id="imageupload"
                                    placeholder="Choose your logo"
                                    accept="image/*"
                                    margin="normal"
                                    className={classes.hiddenDefaultUpload}
                                    onChange={this.onChange}
                                    inputprops={{
                                        shrink: true,
                                    }}

                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} direction="row" justify="flex-end" alignItems="flex-start">
                            <Grid item xs={4} sm={4} md={3} >
                                <Button
                                    id="buttonDelete"
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    onClick={this.onClick}>
                                    Delete
                                </Button>
                            </Grid>
                            <Grid item xs={8} sm={8} md={4}>
                                <label htmlFor="imageupload" className={classes.labelMarginReset} >
                                    <Button
                                        id="buttonUpload"
                                        size="small"
                                        fullWidth
                                        variant="contained"
                                        color="default"
                                        component="span">
                                        Upload
                                    </Button>
                                </label>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
};

BasicDetailsImageAvatarUpload.propTypes = { classes: PropTypes.object.isRequired };

export default (withStyles(basicDetailsImageUploadAvatarStyle)(BasicDetailsImageAvatarUpload));